<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  <div class="isLoaded ">
    @if (beneficiarycards?.length) {
      <div>
        @for (beneficiaryCard of beneficiarycards; track beneficiaryCard) {
          <div class="content-container mb-3">
            <div class="title">
              {{beneficiaryCard.enrollmentName}}
            </div>
            <div class="content">
              <mwp-table [tableColumns]="beneficiaryCardColumns" [dataSource]="getDataTable(beneficiaryCard)" />
            </div>
            <div class="d-flex justify-content-end footer">
              <button class="mwp-button" (click)="addModifyOpen(beneficiaryCard)">
                <mwp-text-translate text="Add/Modify Beneficiaries" jsonKey="addModifyBeneficiaries" />
              </button>
            </div>
          </div>
        }
      </div>
    }
    @if (!beneficiarycards?.length) {
      <div>
        <mwp-table [tableColumns]="beneficiaryCardColumns" [dataSource]="getDataTable(null)" />
      </div>
    }
  </div>
</div>